module.exports = __webpack_public_path__ + "static/media/2.3ed83f3a.png";